/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable unicorn/consistent-function-scoping */
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { loginStyle } from "../../styles/auth/waiting";

import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import jwtDecode from 'jwt-decode';
import useModal from '../../hooks/use-modal';
import { parseDataAzureAD } from '../../utils/azure-ad';
import { useSignInByAzureADCode } from '../../api/identity';
import { setAuth, setAuthAzureAD } from '../../store/auth/slice';
import { setAuthToken, setAuthTokenAzureAD } from '../../store/authToken/slice';

export function Waiting() {
  const Navigate = useNavigate()
  const dispatch = useDispatch();
  const { showModal } = useModal();

  const signByAzureADCode = useSignInByAzureADCode({
    onSuccess: async (res) => {
      dispatch(setAuthToken(res.data.tokenData.token)); // access token jwt binus
      dispatch(setAuth(res.data.user));  // user profile by binus
      
      Navigate('/')
    },
    onError: (error) => {
      showModal({
        title: 'Login Failed',
        message:
          'Your account is not verified, please contact administrator.',
        options: {
          variant: 'failed',
        },
      });
    },
  });

  useEffect(() => {
    if (window.location.hash) {
      const adState = parseDataAzureAD(window.location.hash);
      if (!adState._success) return;

      // console.log(adState.access_token)

      dispatch(setAuthTokenAzureAD(adState.access_token)); // access token jwt azure ad
      dispatch(setAuthAzureAD(jwtDecode(adState.access_token as string))); // user profile by azure ad token

      signByAzureADCode.mutate({
        azure_token: adState.access_token || '',
      });
    }
  }, []);

  return(
    <Stack component="section" sx={loginStyle.contentStack}>
      <Box sx={loginStyle.contentStackBox}>
        <Typography color="primary" sx={loginStyle.contentStackBoxTypography}>
          Your account verification is in progress. This process typically takes 1-3 business days. 
          Once verified, you&apos;ll be able to access your dashboard. Please log in periodically to check your verification status.
        </Typography>
      </Box>
    </Stack>
  )
}